(function() {

    'use strict';

    angular.module('app').
    controller('TruckInformationAuditController', TruckInformationAuditController);

    TruckInformationAuditController.$inject = ['TruckInformationAuditTable'];

    function TruckInformationAuditController(TruckInformationAuditTable) {

        const vm = this;
        init();

        function init() {
            vm.TruckInformationAuditTable = new TruckInformationAuditTable().tableData;
        }

    }
})();



// WEBPACK FOOTER //
// ./js/controllers/manifests/TruckLoadInformationAuditController.js